export const VECTORSTYLE_CHANGE = 'VECTORSTYLES/CHANGE_OF_ACTIVE_VECTORSTYLE';
export const SET_FILTER_RANGE = 'VECTORSTYLES/SET_FILTER_RANGE';
export const CLEAR_VECTORSTYLE = 'VECTORSTYLES/CLEAR_VECTORSTYLE';
export const SET_VECTORSTYLE = 'VECTORSTYLES/SET_VECTORSTYLE';
export const SET_SELECTED_VECTORS = 'VECTORSTYLES/SET_SELECTED';
export const SET_HOVERED_VECTORS = 'VECTORSTYLES/SET_HOVERED_VECTORS';
